// Copyright (c) 2019 Deere & Company
import moment from 'moment';
import React from 'react';

const cellRenderer = params => (
    <a name="claimNumber" data-warrantyClaimId={params.data.warrantyClaimId}>
        {params.data.claimNumber}
    </a>
);

const ExpandedClaimTableColumnDefinitions = [
    // {
    //     checkboxSelection: true,
    //     width: 75,
    // },
    {
        field: 'claimNumber',
        headerName: 'Claim Number',
        sortable: true,
        filter: true,
        width: 150,
        resizable: true,
        pinned: 'left',
        cellRenderer,
    },
    {
        field: 'claimStatusCode',
        headerName: 'Status',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'part.partNumber',
        headerName: 'Part Number',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'attachmentCount',
        headerName: 'Attachment Count',
        sortable: true,
        filter: true,
        maxWidth: 80,
    },
    {
        field: 'part.partDescription',
        headerName: 'Prime Part Description',
        sortable: true,
        filter: true,
        width: 150,
    },
    {
        field: 'functionCodeName',
        headerName: 'Function Code',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'manufacturingModule',
        headerName: 'Mfg Module',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'designTeamCode',
        headerName: 'Design Team',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'pin.digit13',
        headerName: 'PIN',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'pin.digit17',
        headerName: 'PIN 17',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'model',
        headerName: 'Model Code',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'baseCodeName',
        headerName: 'BMC',
        sortable: true,
        filter: true,
        width: 100,
    },
    {
        field: 'modelYear',
        headerName: 'Model Year',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'buildDate',
        headerName: 'Build Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'initialDeliveryDate',
        headerName: 'Initial Delivery Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'failureDate',
        headerName: 'Failure Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    {
        field: 'processDate',
        headerName: 'Process Date',
        sortable: true,
        filter: true,
        width: 120,
        valueFormatter: data => data.value ? moment( data.value * 1000 ).utc().format( 'MM/DD/YYYY' ) : '',
    },
    
    {
        field: 'warrantyYear',
        headerName: 'Warr Yr',
        sortable: true,
        filter: true,
        width: 80,
    },
    {
        field: 'laborHour',
        headerName: 'Labor Hour',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'totalCost',
        headerName: 'Total Cost ($USD)',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'partsCost',
        headerName: 'Parts Cost ($USD)',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'laborCost',
        headerName: 'Labor Cost ($USD)',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'otherCost',
        headerName: 'Other Cost ($USD)',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'diagnosticAmount',
        headerName: 'Diagnostic Amount ($USD)',
        sortable: true,
        filter: true,
        width: 135,
    },
    {
        field: 'diagnosticHours',
        headerName: 'Diagnostic Hour',
        sortable: true,
        filter: true,
        width: 135,
    },

    {
        field: 'regionCode',
        headerName: 'Region',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'branchId',
        headerName: 'Branch',
        sortable: true,
        filter: true,
        width: 80,
    },
    {
        field: 'dealerAccount',
        headerName: 'Dealer',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'dealerState',
        headerName: 'Dlr State',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'creditMemo',
        headerName: 'Credit Memo',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'factoryClaimTypeId',
        headerName: 'Factory Claim Type Code',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'nonMetric',
        headerName: 'Non Metric Code',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'ownerStatusCode',
        headerName: 'Owner Status',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'supplierId',
        headerName: 'Supplier ID',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'componentPin',
        headerName: 'Component 1 PIN',
        sortable: true,
        filter: true,
        width: 120,
    },
    {
        field: 'amountOfUse.amount',
        headerName: 'Mach Use',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'amountOfUse.unit',
        headerName: 'Mach Use Ind',
        sortable: true,
        filter: true,
        width: 90,
    },
    {
        field: 'failureMode',
        headerName: 'Failure Mode Code',
        sortable: true,
        filter: true,
        width: 150,
    },
    {
        field: 'language',
        headerName: 'Language',
        sortable: true,
        filter: true,
        Width: 90,
        tooltip: data => data.value,
    },
    {
        field: 'complaint',
        headerName: 'Complaint',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'cause',
        headerName: 'Cause',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'correction',
        headerName: 'Correction',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'prodSeriesId',
        headerName: 'Product SeriesId',
        sortable: true,
        filter: true,
        maxWidth: 50,
        tooltip: data => data.value,
    },
    {
        field: 'prodSeriesName',
        headerName: 'Product SeriesName',
        sortable: true,
        filter: true,
        maxWidth: 150,
        tooltip: data => data.value,
    },
    {
        field: 'bmcId',
        headerName: 'BMC ID',
        sortable: true,
        filter: true,
        maxWidth: 100,
        tooltip: data => data.value,
    },
    {
        field: 'bmcName',
        headerName: 'BMC Name',
        sortable: true,
        filter: true,
        maxWidth: 100,
        tooltip: data => data.value,
    }
];
export default ExpandedClaimTableColumnDefinitions;
